import PropTypes from 'prop-types';
import React from 'react';
import { Set } from 'immutable';

import t from '../../lib/I18n';
import config from '../../config';
import trainTime from '../../lib/TrainTime';
import SeasonSearch from '../../records/SeasonSearch';
import Smartcard from '../../records/customer/Smartcard';

import SectionErrors from '../search/SectionErrors';
import SeasonDuration from './SeasonDuration';
import SeasonTicketCompact from './SeasonTicketCompact';

function SeasonStartDuration (props) {
    const { search, searchAttempted, searchErrors } = props;

    let errors = [];

    if (searchAttempted) {
        if (searchErrors.has('validateDatesInFuture')) {
            errors.push('booking.dates.errors.pastDate');
        }
        if (searchErrors.has('validateDateLessThanMax')) {
            const maxPeriod = trainTime.duration(
                search.smartcard ? config.get('maxSeasonStartPeriodSmartcard') : config.get('maxSeasonStartPeriod')
            ).humanize();
            errors.push(t('booking.dates.errors.datesAfterMaxPeriod', { maxPeriod }));
        }
        if (searchErrors.has('startAfterSmartcardAwaitingPeriod')) {
            const days = config.get('minAwaitingSmartcardProductDays');
            errors.push(t('booking.dates.errors.datesBeforeSmartcardAwaitingPeriod', { days }));
        }
    }

    if (!search.validateRailcard1617()) {
        const maxValidDate = search.get('railcard1617').getMaximumValidDate();
        errors.push(t('booking.dates.errors.railcard1617Expiry', { date: maxValidDate.format('Do MMMM YYYY') }));
    }

    return (
        <section className="booking__section datetime">
            <SeasonTicketCompact { ...props } error={ errors.join('. ') } />
            <SectionErrors errors={ errors } />
            <SeasonDuration { ...props } />
        </section>
    );
}

SeasonStartDuration.propTypes = {
    search: PropTypes.instanceOf(SeasonSearch).isRequired,
    smartcard: PropTypes.instanceOf(Smartcard),
    onChange: PropTypes.func,
    searchErrors: PropTypes.instanceOf(Set).isRequired,
    searchAttempted: PropTypes.bool
};

export default SeasonStartDuration;



// WEBPACK FOOTER //
// ./src/components/seasonTicket/SeasonStartDuration.js